import React from "react";
import {
    FormControl,
    InputLabel,
    Select,
    MenuItem,
    Checkbox,
    ListItemText,
} from "@material-ui/core";

const MultiSelectCheckbox = ({
    label,
    options,
    selectedValues,
    setSelectedValues,
    getOptionLabel = (option) => option.label,
    getOptionValue = (option) => option.value,
    size = "small",
    fullWidth = true,
    variant = "standard", // Cambiado aquí
}) => {
    const handleChange = (event) => {
        setSelectedValues(event.target.value);
    };

    return (
        <FormControl fullWidth={fullWidth} variant={variant} size={size}>
            <InputLabel>{label}</InputLabel>
            <Select
                multiple
                value={selectedValues}
                onChange={handleChange}
                label={label}
                renderValue={(selected) =>
                    options
                        .filter((opt) => selected.includes(getOptionValue(opt)))
                        .map(getOptionLabel)
                        .join(", ")
                }
                displayEmpty
                MenuProps={{
                    PaperProps: {
                        style: {
                            maxHeight: 300,
                        },
                    },
                }}
            >
                {options
                    .sort((a, b) => getOptionLabel(a).localeCompare(getOptionLabel(b)))
                    .map((option) => {
                        const label = getOptionLabel(option);
                        const value = getOptionValue(option);
                        return (
                            <MenuItem key={value} value={value}>
                                <Checkbox checked={selectedValues.includes(value)} />
                                <ListItemText primary={label} />
                            </MenuItem>
                        );
                    })}
            </Select>
        </FormControl>
    );
};

export default MultiSelectCheckbox;
